import { take, call, put } from 'redux-saga/effects';
import * as types from '../../../lib/actionTypes.es6';
import * as actions from './actions';
import {
  getOrgCustomerStatusConfigs,
  createOrgCustomerStatusConfig,
  updateOrgCustomerStatusConfig,
  deleteOrgCustomerStatusConfig,
} from '../../../lib/orgRequests.es6';
import { GAloggerException } from '../../../lib/monitoring.es6';
import { unAuthorizedNotification } from '../../../lib/access.es6';

function extractError(e) {
  if (e.response && e.response.data) { return e.response.data; }
  return 'An unexpected error occurred';
}

export function* getOrgCustomerStatusConfigsRequestWatcher() {
  for (;;) {
    var request = yield take(types.GET_ORG_CUSTOMER_STATUS_CONFIGS_REQUEST);
    try {
      var response = yield call(getOrgCustomerStatusConfigs, request.payload);
      yield put(actions.getOrgCustomerStatusConfigsSuccess(response.data));
    } catch (e) {
      yield put(actions.getOrgCustomerStatusConfigsFailure(extractError(e)));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* createOrgCustomerStatusConfigRequestWatcher() {
  for (;;) {
    var request = yield take(types.CREATE_ORG_CUSTOMER_STATUS_CONFIG_REQUEST);
    try {
      var response = yield call(createOrgCustomerStatusConfig, request.payload);
      yield put(actions.createOrgCustomerStatusConfigSuccess(response.data));
      yield put(actions.getOrgCustomerStatusConfigsRequest(request.payload.organization_guid));
    } catch (e) {
      yield put(actions.createOrgCustomerStatusConfigFailure(extractError(e)));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* updateOrgCustomerStatusConfigRequestWatcher() {
  for (;;) {
    var request = yield take(types.UPDATE_ORG_CUSTOMER_STATUS_CONFIG_REQUEST);
    try {
      var response = yield call(updateOrgCustomerStatusConfig, request.payload.guid, request.payload);
      yield put(actions.updateOrgCustomerStatusConfigSuccess(response.data));
      yield put(actions.getOrgCustomerStatusConfigsRequest(request.payload.organization_guid));
    } catch (e) {
      yield put(actions.updateOrgCustomerStatusConfigFailure(extractError(e)));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* deleteOrgCustomerStatusConfigRequestWatcher() {
  for (;;) {
    var request = yield take(types.DELETE_ORG_CUSTOMER_STATUS_CONFIG_REQUEST);
    try {
      yield call(deleteOrgCustomerStatusConfig, request.payload.guid);
      yield put(actions.deleteOrgCustomerStatusConfigSuccess(request.payload.guid));
      yield put(actions.getOrgCustomerStatusConfigsRequest(request.payload.organization_guid));
    } catch (e) {
      yield put(actions.deleteOrgCustomerStatusConfigFailure(extractError(e)));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}
